export const CATEGORIES = [
  // { id: 'INTL', name: 'International Companies' },
  // { id: 'NTL', name: 'Indian Companies' },
  { id: 'STB', name: 'State Tourism Boards' },
  { id: 'NTL', name: 'Private Domestic Exhibitors' },
  { id: 'INTL', name: 'Private International Exhibitors' },
  { id: 'NTO', name: 'National Tourism Organisations' },
];

export const CATEGORIES_LIST = {
  'NTO':'NTOs',
  'STB': 'State Tourism Board',
  'NTL': 'Private Company - India',
  'INTL': 'Private Company — International'
}

export const DESK_LIST = {
  'NTO':'Private',
  'STB': 'State Tourism Board',
  'NTL': 'Private',
  'INTL': 'Private'
}

export const SEARCH_KEY = ["searchedText"];

// const isProduction = import.meta.env.VITE_APP_ENV === 'production';

// export const API_BASE_URL = isProduction ? "https://api-prod.otm.co.in" : "https://api-stage.otm.co.in"; 
// export const RECONNECT_API_BASE_URL = isProduction ? 'https://reconnect.eventapp-reconnect.fairfest.in' : 'https://reconnect.stage-eventapp-reconnect.fairfest.in';

export const API_BASE_URL = import.meta.env.VITE_BACKEND_BASE_URL;
export const RECONNECT_API_BASE_URL = import.meta.env.VITE_RECONNECT_BACKEND_BASE_URL;

export const SENSITIVE_ROUTES = [
  "/survey",
  "/details-page",
  "/profile-detail",
  "/success-page",
  "/success-qr-page"
];